import { keepPreviousData } from "@tanstack/react-query";

import { useFetchMutation, useFetchQuery } from "common/queries/hooks";
import { OnboardingEvent } from "common/types/onboarding";

import { OnboardingEventCreate, OnboardingClient } from "../types";
import { keys, urls } from "./constants";
import { useInvalidateOnboarding } from "./invalidate";

const noop = () => null;

export const useOnboardingQuery = () => {
  return useFetchQuery<OnboardingClient>(keys.onboarding(), {
    fetch: { url: urls.onboarding() },
    config: { placeholderData: keepPreviousData },
  });
};

export const useOnboardingEventsMutation = ({
  onSuccess = noop,
  onError,
}: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const invalidateOnboarding = useInvalidateOnboarding();
  return useFetchMutation<OnboardingEventCreate, OnboardingEvent>({
    fetch: (data) => ({ method: "POST", url: urls.events(), body: data }),
    config: {
      onSuccess: () => {
        invalidateOnboarding();
        onSuccess();
      },
      onError,
    },
  });
};
